import { useState } from 'react'
import { useSelector } from 'react-redux'
import { downloadFollowUp } from 'services/results/follow-up'
import { canViewFollowUpComparison } from 'services/results/follow-up-access'
import { useNotification } from 'lib/context/notification.context'
import { StrokedButton } from 'views/components/UI/Buttons'

export default function ProcessFollowUpExports({
  processId,
  hasSkills,
  hasBetesa,
}: {
  processId: number
  hasSkills: boolean
  hasBetesa: boolean
}) {
  const role = useSelector((state: any) => state.auth.role)
  const [busy, setBusy] = useState(false)
  const { getError } = useNotification()
  if (!canViewFollowUpComparison(role) || (!hasSkills && !hasBetesa)) return null
  const download = async (categoryId: number) => {
    if (busy) return
    setBusy(true)
    try {
      await downloadFollowUp(
        processId,
        'excel',
        `FollowUps_${categoryId === 2 ? '3DSkills' : 'Betesa'}_Proceso_${processId}.xlsx`,
        { category_id: categoryId }
      )
    } catch {
      getError('No se pudo descargar el Excel consolidado. Comprueba tus permisos y vuelve a intentarlo.')
    } finally {
      setBusy(false)
    }
  }
  return (
    <section
      aria-label="Descargas consolidadas del proceso"
      style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12, margin: '16px 0 24px' }}
    >
      <span style={{ color: '#526b7d', fontWeight: 600 }}>Descargas del proceso</span>
      {hasSkills && (
        <StrokedButton disabled={busy} onClick={() => download(2)}>
          Excel consolidado 3D Skills
        </StrokedButton>
      )}
      {hasBetesa && (
        <StrokedButton disabled={busy} onClick={() => download(1)}>
          Excel consolidado Betesa
        </StrokedButton>
      )}
    </section>
  )
}
